import styled from 'styled-components';
import { XIColorUsage } from '@inmoment/the-kitchen';

export const HomeWrapper = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
`;

export const MainHome = styled.div`
  display: flex;
  min-width: 400px;
  height: 100%;
  overflow: hidden;
  background: ${XIColorUsage.silver};
`;
